import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import { SettingsProvider } from "./context/SettingsContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import CookieNotice from "./components/CookieNotice";
import { PageGate } from "./components/PageGate";
import NotFound from "./pages/NotFound";
import Home from "./pages/Home";
import Gallery from "./pages/Gallery";
import PrintDetail from "./pages/PrintDetail";
import Cart from "./pages/Cart";
import { PaymentSuccess, PaymentCancel } from "./pages/Payment";
import Commissions from "./pages/Commissions";
import About from "./pages/About";
import Originals from "./pages/Originals";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import Policies from "./pages/Policies";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import { useEffect } from "react";

function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
    return null;
}

function Chrome({ children }) {
    const { pathname } = useLocation();
    const bare = pathname.startsWith("/admin");
    return (
        <>
            {!bare && <Header />}
            <main>{children}</main>
            {!bare && <Footer />}
            {!bare && <CookieNotice />}
        </>
    );
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <CartProvider>
                        <SettingsProvider>
                        <ScrollToTop />
                        <Chrome>
                            <Routes>
                                <Route path="/" element={<Home />} />
                                <Route path="/gallery" element={<PageGate page="gallery"><Gallery /></PageGate>} />
                                <Route path="/originals" element={<PageGate page="originals"><Originals /></PageGate>} />
                                <Route path="/print/:slug" element={<PrintDetail />} />
                                <Route path="/cart" element={<Cart />} />
                                <Route path="/payment/success" element={<PaymentSuccess />} />
                                <Route path="/payment/cancel" element={<PaymentCancel />} />
                                <Route path="/commissions" element={<PageGate page="commissions"><Commissions /></PageGate>} />
                                <Route path="/about" element={<PageGate page="about"><About /></PageGate>} />
                                <Route path="/policies" element={<Policies />} />
                                <Route path="/privacy" element={<Privacy />} />
                                <Route path="/terms" element={<Terms />} />
                                <Route path="/admin/login" element={<AdminLogin />} />
                                <Route path="/admin" element={<AdminDashboard />} />
                                <Route path="*" element={<NotFound />} />
                            </Routes>
                        </Chrome>
                        <Toaster theme="light" position="top-center" />
                        </SettingsProvider>
                    </CartProvider>
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
